module.exports = __webpack_public_path__ + "img/tr-pazarama.a008c8a4.png";